import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React, { useCallback } from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import StarsSquareIconButton from '@swf/components/StarsSquareIconButton/StarsSquareIconButton';
import flags from '@swf/core/assets/flags';
import { select } from '@swf/core/store';

import {
  TXTWCL_Canadian_Citizen,
  TXTWCL_Romanian_Citizen,
  TXTWCL_You_are_a_citizen_of_CanadaX,
  TXTWCL_You_are_a_citizen_of_RomaniaX
} from './Citizenship.messages.json';
import { squareButton, text } from './Citizenship.scss';

interface Props {
  active: boolean;
  handleClick(): void;
}

const Citizenship: React.FC<Props> = ({ active, handleClick }) => {
  const form = useForm();
  const siteId = useSelector(select.cms.getSiteId);
  const detectedCountry = useSelector(select.account.getCountry) as string;

  const getFlag: React.FC = () => (
    <img width={40} height={40} src={flags[detectedCountry]} alt={Sites[siteId]} />
  );

  const translation = {
    [Sites.CA_ON]: TXTWCL_Canadian_Citizen,
    [Sites.ROM]: TXTWCL_Romanian_Citizen
  };

  const subTitle = {
    [Sites.CA_ON]: TXTWCL_You_are_a_citizen_of_CanadaX,
    [Sites.ROM]: TXTWCL_You_are_a_citizen_of_RomaniaX
  };

  const handleCitizenshipClick = useCallback(() => {
    handleClick();
    form.change('citizenship', Sites[siteId]);
  }, [form, handleClick, siteId]);

  return (
    <StarsSquareIconButton
      Icon={getFlag}
      active={active}
      dataTestId="citizenship"
      className={squareButton}
      groupTextClassName={text}
      onClick={handleCitizenshipClick}
      // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
      translation={{ tag: translation[siteId] || TXTWCL_Canadian_Citizen }}
      subTitle={
        <Translation
          tagName="small"
          // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
          {...(subTitle[siteId] || TXTWCL_You_are_a_citizen_of_CanadaX)}
        />
      }
    />
  );
};

export default Citizenship;
